// packages/charts/src/react/EmptyChart.tsx
//
// Render a "No data available" placeholder card with the same
// border/padding as a <ChartFrame> canvas slot. Used by every per-type
// chart component when its data array is empty so the canvas never
// renders as a blank box.
import * as React from "react";

export interface EmptyChartProps {
  ariaLabel: string;
  message?: string;
  /** The frame refused to draw this chart (a type the surface does not
   *  offer), as opposed to an answer with no rows. Marked so the static
   *  edition's drawn check can tell the two apart; looks the same. */
  refused?: boolean;
}

export function EmptyChart({
  ariaLabel,
  message = "No data available",
  refused = false,
}: EmptyChartProps): React.ReactElement {
  return (
    <div
      role="img"
      aria-label={ariaLabel}
      className="verity-chart-empty"
      data-chart-refused={refused ? "" : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        color: "var(--verity-color-text-muted, #6b7280)",
        fontSize: 13,
      }}
    >
      {message}
    </div>
  );
}
